"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The RfqLineRequirement model module.
 * @module model/RfqLineRequirement
 * @version 0.0.1
 */
var RfqLineRequirement = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>RfqLineRequirement</code>.
   * @alias module:model/RfqLineRequirement
   */
  function RfqLineRequirement() {
    _classCallCheck(this, RfqLineRequirement);
    RfqLineRequirement.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(RfqLineRequirement, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>RfqLineRequirement</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/RfqLineRequirement} obj Optional instance to populate.
     * @return {module:model/RfqLineRequirement} The populated <code>RfqLineRequirement</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new RfqLineRequirement();
        if (data.hasOwnProperty('index')) {
          obj['index'] = _ApiClient["default"].convertToType(data['index'], 'Number');
        }
        if (data.hasOwnProperty('requirement_type')) {
          obj['requirement_type'] = _ApiClient["default"].convertToType(data['requirement_type'], 'String');
        }
        if (data.hasOwnProperty('requirement_text')) {
          obj['requirement_text'] = _ApiClient["default"].convertToType(data['requirement_text'], 'String');
        }
      }
      return obj;
    }
  }]);
}();
/**
 * @member {Number} index
 */
RfqLineRequirement.prototype['index'] = undefined;

/**
 * @member {String} requirement_type
 */
RfqLineRequirement.prototype['requirement_type'] = undefined;

/**
 * @member {String} requirement_text
 */
RfqLineRequirement.prototype['requirement_text'] = undefined;
var _default = exports["default"] = RfqLineRequirement;